import { createContext } from "react"

const ServiceContext = createContext<string | undefined>(undefined)

export default ServiceContext
